//Override List
export const FETCH_OVERRIDES_LIST_REQUEST = "FETCH_OVERRIDES_LIST_REQUEST";
export const FETCH_OVERRIDES_LIST_SUCCESS = "FETCH_OVERRIDES_LIST_SUCCESS";
export const FETCH_OVERRIDES_LIST_FAILURE = "FETCH_OVERRIDES_LIST_FAILURE";

//Post Override
export const POST_OVERRIDE_REQUEST = "POST_OVERRIDE_REQUEST";
export const POST_OVERRIDE_SUCCESS = "POST_OVERRIDE_SUCCESS";
export const POST_OVERRIDE_FAILURE = "POST_OVERRIDE_FAILURE";

//Put Override
export const PUT_OVERRIDE_REQUEST = "PUT_OVERRIDE_REQUEST";
export const PUT_OVERRIDE_SUCCESS = "PUT_OVERRIDE_SUCCESS";
export const PUT_OVERRIDE_FAILURE = "PUT_OVERRIDE_FAILURE";

//Get Override Id
export const FETCH_OVERRIDE_REQUEST = "FETCH_OVERRIDE_REQUEST";
export const FETCH_OVERRIDE_SUCCESS = "FETCH_OVERRIDE_SUCCESS";
export const FETCH_OVERRIDE_FAILURE = "FETCH_OVERRIDE_FAILURE";

//Delete Override Id
export const DELETE_OVERRIDE_REQUEST = "DELETE_OVERRIDE_REQUEST";
export const DELETE_OVERRIDE_SUCCESS = "DELETE_OVERRIDE_SUCCESS";
export const DELETE_OVERRIDE_FAILURE = "DELETE_OVERRIDE_FAILURE";
